module footer {
  'use strict';

  export class FooterConfig {
    
    public static $inject = [
      '$locationProvider'
    ];

    constructor(
      $locationProvider: ng.ILocationProvider
      ) { 

      $locationProvider.html5Mode(true);
    }

    
  }
  
}